import React, { useState, useEffect } from 'react';
import { Flame, Clock } from 'lucide-react';
import BookingModal from './BookingModal';
import Loader from './Loader';
import { optimizeImageUrl } from '@/lib/imageUtils';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const LastMinuteDeals = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState({ title: '', destination: '' });
  const [lastMinuteDeals, setLastMinuteDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/last-minute-deals`)
      .then(res => res.json())
      .then(data => {
        setLastMinuteDeals(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching last minute deals:', err);
        setLoading(false);
      });
  }, []);

  const handleBookNow = (deal) => {
    setSelectedDeal({ title: deal.title, destination: deal.destination });
    setIsBookingModalOpen(true);
  };

  if (loading) {
    return (
      <section id="packages" className="last-minute-section">
        <div className="section-header">
          <Flame className="section-icon flame" />
          <h2 className="section-title">Last Minute International Deals</h2>
          <p className="section-subtitle">Limited time offers on amazing destinations</p>
        </div>
        <Loader />
      </section>
    );
  }

  return (
    <section id="packages" className="last-minute-section">
      <div className="section-header">
        <Flame className="section-icon flame" />
        <h2 className="section-title">Last Minute International Deals</h2>
        <p className="section-subtitle">Limited time offers on amazing destinations</p>
      </div>

      <div className="deals-grid">
        {lastMinuteDeals.slice(0, 3).map((deal) => (
          <div key={deal.id} className="deal-card">
            <div className="deal-image-wrapper">
              <img
                src={optimizeImageUrl(deal.image, 600)}
                alt={deal.destination}
                className="deal-image"
                loading="lazy"
                decoding="async"
              />
              <div className="deal-badge discount">{deal.discount}</div>
            </div>

            <div className="deal-content">
              <div className="deal-destination">{deal.destination}</div>
              <h3 className="deal-title">{deal.title}</h3>
              
              <div className="deal-dates">
                <Clock size={16} />
                <span>{deal.travelDates}</span>
              </div>

              <p className="deal-includes">{deal.includes}</p>

              <div className="deal-pricing-only">
                <span className="original-price">{deal.originalPrice}</span>
                <span className="deal-price">{deal.price}</span>
              </div>

              <button 
                onClick={() => handleBookNow(deal)}
                className="book-now-btn"
                data-testid={`book-now-deal-${deal.id}`}
              >
                Book Now
              </button>
            </div>
          </div>
        ))}
      </div>

      <BookingModal 
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        dealTitle={selectedDeal.title}
        destination={selectedDeal.destination}
      />
    </section>
  );
};

export default LastMinuteDeals;
